
export enum Bandeira {
    CASAS_BAHIA = 'CASAS_BAHIA',
    PONTOFRIO = 'PONTOFRIO'
}
